import React, { useEffect, useState } from "react";
import { InputGroup, Table } from "react-bootstrap";
import Swal from "sweetalert2";
import { askReportFormat, saveReport } from "../../../utils/reportExport";
import { useParams } from "react-router-dom";
import TableProperties from "./TableProperties";
import Moment from "react-moment";
import UseToggle from "../../../Hooks/UseToggle";
import { studySiteDataEntryServices } from "../../../APIServices/studySiteDataEntryServices";
import { studyOtherSettingsServices } from "../../../APIServices/studyOtherSettingsServices";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import ManagementFilterCanvas from "../ManagementFilterCanvas";
import { studyLevelFormManagementServices } from "../../../APIServices/studyLevelFormManagementServices";
import { studySiteManagementServices } from "../../../APIServices/CTMS/SiteManagement/studySiteManagementServices";
import { studySubjectManagementServices } from "../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";
import { studyEventManagementServices } from "../../../APIServices/CTMS/EventManagement/studyEventManagementServices";
import Pagination from "../../Pagination";
import FieldQueryHistory from "./FieldQuery/FieldQueryHistory";
import { isHTMLIdentifier } from "../../../utils/universalFunction";
import SplitPane from "react-split-pane";

const ManageQueryDataList = ({ onMouseDown, tableRef, handleAddNewTab }) => {
  const [queryList, setQueryList] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [siteId, setSiteId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [eventId, setEventId] = useState("");
  const [timePointId, setTimePointId] = useState("");
  const [type, setType] = useState("");
  const [formList, setFormList] = useState([]);
  const [formId, setFormId] = useState("");
  const [repeatEvent, setRepeatEvent] = useState("");
  const [repeatForm, setRepeatForm] = useState("");
  const [answered, setAnswered] = useState("");
  const [status, setStatus] = useState("ALL");
  const [queryListCount, setQueryListCount] = useState(0);
  const [responseMessage, setResponseMessage] = useState("");
  const [reasonMessage, setReasonMessage] = useState("");
  const [queryData, setQueryData] = useState("");
  const [dataEntryQueryDiscussion, setDataEntryQueryDiscussion] = useState([]);
  const [dataEntryQueryDiscussionLoader, setDataEntryQueryDiscussionLoader] = useState(false);
  const [queryButtonLoader, setQueryButtonLoader] = useState(false);
  const [queryStatusButtonLoader, setQueryStatusButtonLoader] = useState(false);
  const [reOpenqueryButtonLoader, setReOpenQueryButtonLoader] = useState(false);
  const { toggle, setToggle, toggle2, setToggle2, toggle1, setToggle1 } = UseToggle();
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [tableColumns, setTableColumns] = useState({});
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();

  const formColumn = [
    { columnLabel: "SiteId", columnName: "SITEID", columnType: "text" },
    { columnLabel: "SubjectId", columnName: "SUBJECTID", columnType: "text" },
    { columnLabel: "EventId", columnName: "EVENTID", columnType: "text" },
    { columnLabel: "TimepointId", columnName: "TIMEPOINTID", columnType: "text" },
    { columnLabel: "Repeat Event", columnName: "REPEATEVENT", columnType: "text" },
    { columnLabel: "Form Name", columnName: "FORMNAME", columnType: "text" },
    { columnLabel: "Form Version", columnName: "FORMVERSION", columnType: "text" },
    { columnLabel: "Repeat Form", columnName: "REPEATFORM", columnType: "text" },
    { columnLabel: "Field Name", columnName: "FIELDNAME", columnType: "text" },
    { columnLabel: "Sub Field Name", columnName: "SUBFIELDNAME", columnType: "text" },
    { columnLabel: "First Generated Date | Time", columnName: "FIRSTGENERATEDDT", columnType: "text", },
    { columnLabel: "Last Generated Date | Time", columnName: "LASTGENERATEDDT", columnType: "text", },
    { columnLabel: "Query Age", columnName: "QUERYAGE", columnType: "text" },
    { columnLabel: "Query Type", columnName: "QUERYTYPE", columnType: "text" },
    { columnLabel: "Due Date", columnName: "DUEDATE", columnType: "text" },
    { columnLabel: "Overdue", columnName: "OVERDUE", columnType: "text" },
    { columnLabel: "Status", columnName: "QUERYSTATUS", columnType: "text" },
    { columnLabel: "Answered", columnName: "ANSWERED", columnType: "text" },
  ];

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const [totalPage, setTotalPage] = useState(0);
  const startIndex = (pageNumber - 1) * itemsPerPage;

  const queryTypeOptions = [
    { label: "Auto", value: "auto" },
    { label: "Manual", value: "manual" },
  ];

  const initialFilters = {
    siteId: "",
    subjectId: "",
    eventId: "",
    timePointId: "",
    type: "",
    status: "ALL",
    formId: "",
    repeatEvent: "",
    repeatForm: "",
    answered: "",
  };
  // Filters sent to the API; the offcanvas edits draft values that are only applied on "Filter selection"
  const [appliedFilters, setAppliedFilters] = useState(initialFilters);

  const setDraftFilters = (filters) => {
    setSiteId(filters.siteId);
    setSubjectId(filters.subjectId);
    setEventId(filters.eventId);
    setTimePointId(filters.timePointId);
    setType(filters.type);
    setStatus(filters.status);
    setFormId(filters.formId);
    setRepeatEvent(filters.repeatEvent);
    setRepeatForm(filters.repeatForm);
    setAnswered(filters.answered);
  };

  const buildQueryHistoryRequest = (includePagination = true, overrides = {}) => {
    const request = {
      studyId,
      mode: StudyMode,
      ...appliedFilters,
    };
    if (includePagination) {
      request.page = pageNumber;
      request.length = itemsPerPage;
    }
    return { ...request, ...overrides };
  };

  const getStudyFormFieldQueryHistory = async (overrides = {}) => {
    setLoading(true);
    let data = await studySiteDataEntryServices.getStudyFormFieldQueryHistory(
      buildQueryHistoryRequest(true, overrides)
    );
    setLoading(false);
    if (data === "AbortError") {
      setLoading(true);
    } else {
      setQueryList(data?.data || []);
      setTotalPage(data?.totalPages || 0);
      setQueryListCount(data?.count || 0);
      setLoading(false)
    }
  };

  const downloadQueryReport = async () => {
    const format = await askReportFormat();
    if (!format) return;
    setExportLoading(true);
    try {
      const response = await studySiteDataEntryServices.getStudyFormFieldQueryHistory(
        { ...buildQueryHistoryRequest(false), status: "ALL" },
        false
      );
      const reportData = Array.isArray(response?.data) ? response.data : [];
      if (!reportData.length) {
        await Swal.fire({
          icon: "info",
          title: "No query data",
          text: response?.customMessage || "No query data is available for this report.",
        });
        return;
      }

      const toPlainText = (value) => {
        const text = String(value ?? "");
        return isHTMLIdentifier(text)
          ? new DOMParser().parseFromString(text, "text/html").body.textContent || ""
          : text;
      };
      const capitalizeText = (value) => String(value ?? "").replace(/\b[a-z]/g, (character) => character.toUpperCase());
      const formatDateTime = (value) => {
        if (!value) return "";
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return String(value);
        const datePart = date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
        const timePart = date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false });
        return `${datePart} | ${timePart}`;
      };
      const formatField = (label, name) => {
        const labelText = toPlainText(label);
        return label === name ? labelText : `${labelText} | ${name ?? ""}`;
      };

      const columns = [
        { label: "Sr.", value: (_, index) => index + 1 },
        { key: "SITEID", label: "SiteId", value: (query) => query?.siteName },
        { key: "SUBJECTID", label: "SubjectId", value: (query) => query?.subjectName },
        { key: "EVENTID", label: "EventId", value: (query) => query?.dataEntryType === "specialForm" ? "Special Form" : query?.eventName },
        { key: "TIMEPOINTID", label: "TimepointId", value: (query) => query?.timePointId || "_" },
        { key: "REPEATEVENT", label: "Repeat Event", value: (query) => query?.repeatEvent },
        { key: "FORMNAME", label: "Form Name", value: (query) => query?.formName },
        { key: "FORMVERSION", label: "Form Version", value: (query) => `v${query?.formVersion}` },
        { key: "REPEATFORM", label: "Repeat Form", value: (query) => query?.repeatForm },
        { key: "FIELDNAME", label: "Field Name | Label", value: (query) => formatField(query?.mainFieldLabel, query?.mainFieldName) },
        { key: "SUBFIELDNAME", label: "Sub Field Name | Label", value: (query) => formatField(query?.fieldLabel, query?.fieldName) },
        { key: "FIRSTGENERATEDDT", label: "First Generated Date | Time", value: (query) => formatDateTime(query?.createdAt) },
        { key: "LASTGENERATEDDT", label: "Last Generated Date | Time", value: (query) => formatDateTime(query?.dueAge) },
        { key: "QUERYAGE", label: "Query Age", value: (query) => capitalizeText(query?.queryAge) },
        { key: "QUERYTYPE", label: "Query Type", value: (query) => capitalizeText(`${query?.queryType} Query`) },
        { key: "ANSWERED", label: "Answered", value: (query) => query?.actionStatus === "open" ? "No" : "Yes" },
        { key: "DUEDATE", label: "Due Date", value: (query) => capitalizeText(query?.dueDate) },
        { key: "OVERDUE", label: "Overdue", value: (query) => capitalizeText(query?.isOverdue) },
        { key: "QUERYSTATUS", label: "Status", value: (query) => capitalizeText(query?.actionStatus) },
      ].filter((column) => !column.key || !tableColumns[column.key]);

      const csvRows = [
        columns.map((column) => column.label),
        ...reportData.map((query, index) => columns.map((column) => column.value(query, index) ?? "")),
      ];
      saveReport(csvRows, format, "Query_Report");
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Report download failed",
        text: error?.message || "Unable to export query report.",
      });
    } finally {
      setExportLoading(false);
    }
  };

  const getTablePropertiesData = async (e) => {
    let data = await studyOtherSettingsServices.getTablePropertiesData(
      "studyLevelDataQuery",
      studyId
    );
    setTableColumns(data?.data || {});
  };

  const getStudySiteBasedonAccess = async () => {
    let data = await studySiteManagementServices.getStudySiteBasedonAccess(studyId, LoginCat, StudyMode)
    setSiteList(data?.data || [])
  }

  const getStudySubjectRowData = async (isCurrent = () => true) => {
    let data = await studySubjectManagementServices.getStudySubjectRowData("active", studyId, siteId, StudyMode)
    if (isCurrent()) setSubjectList(data?.data || [])
  }

  const getStudyEventRowData = async () => {
    let data = await studyEventManagementServices.getStudyEventRowData("active", studyId)
    setEventList(data?.data || [])
  }

  const getStudyLevelForm = async () => {
    let data = await studyLevelFormManagementServices.getStudyLevelForm(studyId, "edc", "active", StudyMode)
    setFormList(data?.data || [])
  }

  useEffect(() => {
    getTablePropertiesData();
    getStudySiteBasedonAccess()
    getStudyEventRowData()
    getStudyLevelForm()
  }, []);

  useEffect(() => {
    let current = true;
    setSubjectList([]);
    if (siteId) {
      // Ignore a late response for a site that is no longer selected
      getStudySubjectRowData(() => current);
    }
    return () => {
      current = false;
    };
  }, [siteId]);

  useEffect(() => {
    if (pageNumber < 1) return;
    getStudyFormFieldQueryHistory();
  }, [appliedFilters, pageNumber, itemsPerPage]);

  const applyFilters = () => {
    setAppliedFilters({ siteId, subjectId, eventId, timePointId, type, status, formId, repeatEvent, repeatForm, answered });
    setPageNumber(1);
  };

  const resetFilters = () => {
    setDraftFilters(initialFilters);
    setAppliedFilters(initialFilters);
    setPageNumber(1);
  };

  const changeStatus = (value) => {
    setStatus(value);
    setAppliedFilters((prev) => ({ ...prev, status: value }));
    setPageNumber(1);
  };

  const openFilter = () => {
    // Show the filters that are actually applied, dropping unapplied edits
    if (toggle) setDraftFilters(appliedFilters);
    setToggle();
  };

  const updateTableProperties = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Update Table Property!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Update it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.type = "studyLevelDataQuery";
        userData.columns = tableColumns;
        let data = await studyOtherSettingsServices.updateTableProperties(
          userData
        );
        if (data?.statusCode === 200) {
          getStudyFormFieldQueryHistory();
          getTablePropertiesData();
        }
      }
    });
  };

  const queryDiscussionStudySubjectFormField = async (siteId, subjectId, formId, queryId) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Response this query!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Response it!`,
    }).then(async (result) => {
      setQueryButtonLoader(true)
      let userData = {}
      userData.studyId = studyId
      userData.siteId = siteId
      userData.subjectId = subjectId
      userData.formId = formId
      userData.queryId = queryId
      userData.message = responseMessage
      if (result.isConfirmed) {
        let data = await studySiteDataEntryServices.queryDiscussionStudySubjectFormField(userData);
        if (data?.statusCode === 200) {
          setResponseMessage("")
          getStudySubjectFormFieldQueryDiscussionDataEntry(siteId, subjectId, formId, queryId)
        }
      }
      setQueryButtonLoader(false)
    });
  }

  const generateManualQueryStatusStudySubjectFormField = async (siteId, subjectId, schemaId, eventId, timePointUniqueId, formId, queryId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${status === "close" ? "Close" : "Cancel"} this query!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status === "close" ? "Close" : "Cancel"} it!`,
    }).then(async (result) => {
      setQueryStatusButtonLoader(status)
      let userData = {}
      userData.studyId = studyId
      userData.siteId = siteId
      userData.subjectId = subjectId
      userData.schemaId = schemaId
      userData.eventId = eventId
      if (timePointUniqueId) {
        userData.timePointUniqueId = timePointUniqueId
      }
      userData.mode = StudyMode
      userData.formId = formId
      userData.queryId = queryId
      userData.status = status
      if (status === "cancel") {
        userData.message = reasonMessage
      }
      if (result.isConfirmed) {
        let data = await studySiteDataEntryServices.generateManualQueryStatusStudySubjectFormField(userData);
        if (data?.statusCode === 200) {
          setToggle1()
          setReasonMessage("")
          getStudyFormFieldQueryHistory()
        }
      }
      setQueryStatusButtonLoader("")
    });
  }

  const getStudySubjectFormFieldQueryDiscussionDataEntry = async (siteId, subjectId, formId, queryId) => {
    setDataEntryQueryDiscussionLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = siteId
    userData.subjectId = subjectId
    userData.formId = formId
    userData.queryId = queryId
    let data = await studySiteDataEntryServices.getStudySubjectFormFieldQueryDiscussionDataEntry(userData)
    if (data === "AbortError") {
      setDataEntryQueryDiscussionLoader(true);
    } else {
      setDataEntryQueryDiscussion(data?.data || [])
      setDataEntryQueryDiscussionLoader(false)
    }
  }

  const reOpenQueryStudySubjectFormField = async (siteId, formId, queryId) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Re-open this query!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, e-open it!`,
    }).then(async (result) => {
      setReOpenQueryButtonLoader(true)
      let userData = {}
      userData.studyId = studyId
      userData.siteId = siteId
      userData.formId = formId
      userData.queryId = queryId
      userData.message = reasonMessage
      if (result.isConfirmed) {
        let data = await studySiteDataEntryServices.reOpenQueryStudySubjectFormField(userData);
        if (data?.statusCode === 200) {
          setToggle1()
          setReasonMessage("")
          getStudySubjectFormFieldQueryDiscussionDataEntry(siteId, subjectId, formId, queryId)
          getStudyFormFieldQueryHistory()
        }
      }
      setReOpenQueryButtonLoader(false)
    });
  }

  const statusList = [
    { label: "All", value: "ALL" },
    { label: "Open", value: "open" },
    { label: "Answered", value: "answered" },
    { label: "Closed", value: "close" },
    { label: "Re-opened", value: "re-open" },
    { label: "Overdue", value: "overdue" },
    { label: "Cancelled", value: "cancel" },
  ];

  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 36 }}
      >
        <div className="hstack gap-1">
          <InputGroup className="w-auto">
            <button
              onClick={openFilter}
              title="Open Filter"
              className={`updateProfile ${!toggle
                ? "activee"
                : ""
                }`}
            >
              <i style={{ fontSize: 8 }} className="fa-solid fa-filter"></i>
            </button>
            {statusList?.map((item, index) => (
              <button
                key={index}
                onClick={() => changeStatus(item?.value)}
                className={`updateProfile ${appliedFilters.status === item?.value
                  ? "activee"
                  : ""
                  }`}
              >
                {item?.label}
              </button>
            ))}
          </InputGroup>
        </div>
        <div className="hstack gap-2">
          {queryListCount > 0 && (
            <div className="gap-1 hstack">
              <button
                type="button"
                onClick={downloadQueryReport}
                className="updateProfile"
                disabled={exportLoading}
              >
                <i className="fa-solid fa-download me-1" aria-hidden="true" />
                {exportLoading ? "Preparing Report..." : "Download Report"}
              </button>
              <button
                onClick={() => {
                  setToggle2();
                  getTablePropertiesData();
                }}
                className={`updateProfile`}
              >
                Table Properties
              </button>
            </div>
          )}
        </div>
      </div>
      <SplitPane
        split="horizontal"
        minSize={"100%"}
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
      >
        {loading ? (
          <PageLoader />
        ) : queryListCount === 0 ? (
          <NoDataFoundTable MSG={"Query data list not found!"} />
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table w-auto" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    Sr.
                  </th>
                  {!tableColumns["SITEID"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 1)} style={{ width: 55 }}>SiteId</th>
                  )}
                  {!tableColumns["SUBJECTID"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 2)} style={{ width: 85 }}>SubjectId</th>
                  )}
                  {!tableColumns["EVENTID"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 3)}>EventId</th>
                  )}
                  {!tableColumns["TIMEPOINTID"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 4)}>TimepointId</th>
                  )}
                  {!tableColumns["REPEATEVENT"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 5)} style={{ width: 85 }}>Repeat Event</th>
                  )}
                  {!tableColumns["FORMNAME"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 6)}>Form Name</th>
                  )}
                  {!tableColumns["FORMVERSION"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 7)}>Form Version</th>
                  )}
                  {!tableColumns["REPEATFORM"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 8)}>Repeat Form</th>
                  )}
                  {!tableColumns["FIELDNAME"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 9)}>Field Name | Label</th>
                  )}
                  {!tableColumns["SUBFIELDNAME"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 10)}>Sub Field Name | Label</th>
                  )}
                  {!tableColumns["FIRSTGENERATEDDT"] && (
                    <th
                      style={{ width: 150 }}
                      onMouseDown={(e) => onMouseDown(e, 11)}
                    >
                      First Generated Date | Time
                    </th>
                  )}
                  {!tableColumns["LASTGENERATEDDT"] && (
                    <th
                      style={{ width: 150 }}
                      onMouseDown={(e) => onMouseDown(e, 12)}
                    >
                      Last Generated Date | Time
                    </th>
                  )}
                  {!tableColumns["QUERYAGE"] && (
                    <th
                      style={{ width: 80 }}
                      onMouseDown={(e) => onMouseDown(e, 13)}
                    >
                      Query Age
                    </th>
                  )}
                  {!tableColumns["QUERYTYPE"] && (
                    <th
                      style={{ width: 85 }}
                      onMouseDown={(e) => onMouseDown(e, 14)}
                    >
                      Query Type
                    </th>
                  )}
                  {!tableColumns["ANSWERED"] && (
                    <th
                      style={{ width: 65 }}
                      onMouseDown={(e) => onMouseDown(e, 15)}
                    >
                      Answered
                    </th>
                  )}
                  {!tableColumns["DUEDATE"] && (
                    <th
                      style={{ width: 50 }}
                      onMouseDown={(e) => onMouseDown(e, 16)}
                    >
                      Due Date
                    </th>
                  )}
                  {!tableColumns["OVERDUE"] && (
                    <th
                      style={{ width: 50 }}
                      onMouseDown={(e) => onMouseDown(e, 17)}
                    >
                      Overdue
                    </th>
                  )}
                  {!tableColumns["QUERYSTATUS"] && (
                    <th
                      style={{ width: 50 }}
                      onMouseDown={(e) => onMouseDown(e, 18)}
                    >
                      Status
                    </th>
                  )}
                  <th
                    onMouseDown={(e) => onMouseDown(e, 19)}
                    style={{ width: 80 }}
                    className="text-center"
                  >
                    View Query
                  </th>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 20)}
                    style={{ width: 80 }}
                    className="text-center"
                  >
                    View Form
                  </th>
                </tr>
              </thead>
              <tbody>
                {queryList?.map((query, index) => (
                  <tr key={index} title="View Details">
                    <td className="text-center">{index + 1 + startIndex}.</td>
                    {!tableColumns["SITEID"] && <td>{query?.siteName}</td>}
                    {!tableColumns["SUBJECTID"] && (
                      <td>{query?.subjectName}</td>
                    )}
                    {!tableColumns["EVENTID"] && (
                      query?.dataEntryType === "specialForm" ?
                        <td>
                          Special Form
                        </td>
                        :
                        <td>
                          {query?.eventName}
                        </td>
                    )}
                    {!tableColumns["TIMEPOINTID"] && (
                      <td>
                        {query?.timePointId ? query?.timePointId : "_"}
                      </td>
                    )}
                    {!tableColumns["REPEATEVENT"] && (
                      <td>
                        {query?.repeatEvent}
                      </td>
                    )}
                    {!tableColumns["FORMNAME"] && (
                      <td>
                        {query?.formName}
                      </td>
                    )}
                    {!tableColumns["FORMVERSION"] && (
                      <td>
                        v{query?.formVersion}
                      </td>
                    )}
                    {!tableColumns["REPEATFORM"] && (
                      <td>
                        {query?.repeatForm}
                      </td>
                    )}
                    {!tableColumns["FIELDNAME"] &&
                      <td>
                        {query?.mainFieldName === query?.mainFieldLabel ? (
                          query?.mainFieldLabel
                        ) : (
                          <>
                            {isHTMLIdentifier(query?.mainFieldLabel || "") ? (
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: query?.mainFieldLabel,
                                }}
                              />
                            ) : (
                              query?.mainFieldLabel
                            )} | {query?.mainFieldName}
                          </>
                        )}
                      </td>
                    }
                    {!tableColumns["SUBFIELDNAME"] &&
                      <td>
                        {query?.fieldName === query?.fieldLabel ? (
                          query?.fieldLabel
                        ) : (
                          <>
                            {isHTMLIdentifier(query?.fieldLabel || "") ? (
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: query?.fieldLabel,
                                }}
                              />
                            ) : (
                              query?.fieldLabel
                            )} | {query?.fieldName}
                          </>
                        )}
                      </td>
                    }
                    {!tableColumns["FIRSTGENERATEDDT"] && (
                      <td>
                        <Moment format="DD MMM YYYY | HH:mm" withTitle>
                          {query?.createdAt}
                        </Moment>
                      </td>
                    )}
                    {!tableColumns["LASTGENERATEDDT"] && (
                      <td>
                        <Moment format="DD MMM YYYY | HH:mm" withTitle>
                          {query?.dueAge}
                        </Moment>
                      </td>
                    )}
                    {!tableColumns["QUERYAGE"] && (
                      <td className="text-capitalize">{query?.queryAge}</td>
                    )}
                    {!tableColumns["QUERYTYPE"] && (
                      <td className={`text-capitalize ${query?.queryType === "auto" ? "text-primary" : "text-info"}`}>{query?.queryType} Query</td>
                    )}
                    {!tableColumns["ANSWERED"] && (
                      <td className={`text-capitalize`}>
                        {query?.actionStatus === "open" ? "No" : "Yes"}
                      </td>
                    )}
                    {!tableColumns["DUEDATE"] && (
                      <td className="text-capitalize">{query?.dueDate}</td>
                    )}
                    {!tableColumns["OVERDUE"] && (
                      <td className="text-capitalize">{query?.isOverdue}</td>
                    )}
                    {!tableColumns["QUERYSTATUS"] && (
                      <td
                        className={`text-capitalize ${(query?.actionStatus === "open" || query?.actionStatus === "re-open")
                          ? "text-danger"
                          : query?.actionStatus === "close"
                            ? "text-success"
                            : "text-muted"
                          }`}
                      >
                        {query?.actionStatus}
                      </td>
                    )}
                    <td className={`text-capitalize text-center`}>
                      <button
                        onClick={() => { setToggle1(); setQueryData(query) }}
                        className={`updateProfile`}
                        style={{ padding: "1px 10px" }}
                      >
                        View Query
                      </button>
                    </td>
                    <td className={`text-capitalize text-center`}>
                      <button
                        onClick={() =>
                          handleAddNewTab(
                            query?.dataEntryType === "specialForm" ?
                              `Site: ${query?.siteName} - Subject: ${query?.subjectName} - Event: Special Event` :
                              query?.timePointLabel ?
                                `Site: ${query?.siteName} - Subject: ${query?.subjectName} - Event: ${query?.eventName} (${query?.timePointLabel})` :
                                `Site: ${query?.siteName} - Subject: ${query?.subjectName} - Event: ${query?.eventName}`,
                            "",
                            query?.dataEntryType === "specialForm" ?
                              `viewEventSchemaFormLists_${query?.siteId}_${query?.subjectId}_${query?.subjectId}SpecialForm`
                              : query?.timePointUniqueId ?
                                `viewEventSchemaFormLists_${query?.siteId}_${query?.subjectId}_${query?.eventId}_repeatEventId_${query?.timePointUniqueId}_repeatTimePointId`
                                : `viewEventSchemaFormLists_${query?.siteId}_${query?.subjectId}_${query?.eventId}_repeatEventId`,
                            {
                              siteId: query?.siteId,
                              siteName: query?.siteName,
                              subjectId: query?.subjectId,
                              subjectName: query?.subjectName,
                              schemaId: query?.schemaId,
                              formId: query?.formId,
                              formName: query?.formName,
                              formVersion: query?.formVersion,
                              formType: query?.formType,
                              recordId: query?.recordId,
                              type: query?.dataEntryType,
                              autoForm: "yes",
                              viewType: "dataEntry",
                              eventId: query?.eventId,
                              eventName: query?.eventName,
                              timePointUniqueId: query?.timePointUniqueId
                                ? String(query?.timePointUniqueId)
                                : "",
                              timePointId: query?.timePointUniqueId
                                ? query?.timePointId
                                : "",
                              repeatEventId: "",
                              repeatTimePointId: ""
                            }
                          )
                        }
                        className={`updateProfile`}
                        style={{ padding: "1px 10px" }}
                      >
                        View Form
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={queryListCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )}
      </SplitPane>
      <TableProperties
        Show={!toggle2}
        Hide={setToggle2}
        Title={`Table Properties`}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        formColumn={formColumn}
        tableColumns={tableColumns}
        setTableColumns={setTableColumns}
        updateTableProperties={updateTableProperties}
      />
      <ManagementFilterCanvas
        Show={!toggle}
        Hide={setToggle}
        Title={`Filter`}
        siteList={siteList}
        subjectList={subjectList}
        eventList={eventList}
        siteId={siteId}
        setSiteId={setSiteId}
        subjectId={subjectId}
        setSubjectId={setSubjectId}
        eventId={eventId}
        setEventId={setEventId}
        timePointId={timePointId}
        setTimePointId={setTimePointId}
        typeOptions={queryTypeOptions}
        type={type}
        setType={setType}
        formList={formList}
        formId={formId}
        setFormId={setFormId}
        repeatEvent={repeatEvent}
        setRepeatEvent={setRepeatEvent}
        repeatForm={repeatForm}
        setRepeatForm={setRepeatForm}
        statusOptions={statusList}
        status={status}
        setStatus={setStatus}
        answeredOptions={[{ label: "Yes", value: "yes" }, { label: "No", value: "no" }]}
        answered={answered}
        setAnswered={setAnswered}
        onApply={applyFilters}
        onReset={resetFilters}
      />

      <FieldQueryHistory
        Show={!toggle1}
        Hide={setToggle1}
        Title={`${queryData?.mainFieldName} Query Summary`}
        queryData={queryData}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        queryButtonLoader={queryButtonLoader}
        queryStatusButtonLoader={queryStatusButtonLoader}
        reOpenqueryButtonLoader={reOpenqueryButtonLoader}
        dataEntryQueryDiscussionLoader={dataEntryQueryDiscussionLoader}
        reOpenQueryStudySubjectFormField={reOpenQueryStudySubjectFormField}
        queryDiscussionStudySubjectFormField={queryDiscussionStudySubjectFormField}
        generateManualQueryStatusStudySubjectFormField={generateManualQueryStatusStudySubjectFormField}
        getStudySubjectFormFieldQueryDiscussionDataEntry={getStudySubjectFormFieldQueryDiscussionDataEntry}
        setResponseMessage={setResponseMessage}
        responseMessage={responseMessage}
        setReasonMessage={setReasonMessage}
        reasonMessage={reasonMessage}
        dataEntryQueryDiscussion={dataEntryQueryDiscussion}
      />
    </>
  );
};

export default ManageQueryDataList;
